(function () {
  'use strict';

  var SELECTOR = '[data-cleeny-product-builder]';

  function parseJSON(section) {
    var node = section.querySelector('[data-product-json]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function money(cents, currency) {
    var value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(2);
    }
  }

  function initGallery(section) {
    var image = section.querySelector('[data-fpb-main-image]');
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-fpb-gallery-dot]'));
    var prev = section.querySelector('[data-fpb-prev]');
    var next = section.querySelector('[data-fpb-next]');
    if (!image || !dots.length) return;

    var index = 0;

    function show(nextIndex) {
      index = (nextIndex + dots.length) % dots.length;
      var dot = dots[index];
      var nextSrc = dot.dataset.src || '';

      if (nextSrc) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.setAttribute('src', nextSrc);
      }

      if (dot.dataset.alt) image.alt = dot.dataset.alt;

      dots.forEach(function (item, itemIndex) {
        var active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () { show(dotIndex); });
    });
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
  }

  function initCollapsibles(section) {
    section.querySelectorAll('[data-cleeny-collapsible-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var content = button.parentElement.querySelector('[data-cleeny-collapsible-content]');
        if (!content) return;
        var opening = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', opening ? 'true' : 'false');
        content.hidden = !opening;
      });
    });
  }

  function initBuilder(section) {
    if (!section || section.dataset.cleenyBuilderReady === 'true') return;
    section.dataset.cleenyBuilderReady = 'true';

    initGallery(section);
    initCollapsibles(section);

    var product = parseJSON(section) || {};
    var currency = section.dataset.currency || 'USD';
    var singleTotal = Number(section.dataset.singleTotal || 1499);
    var doubleTotal = Number(section.dataset.doubleTotal || 2799);
    var whatsappNumber = section.dataset.whatsappNumber || '';

    var radios = Array.prototype.slice.call(section.querySelectorAll('[data-cleeny-bundle-radio]'));
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-cleeny-bundle-card]'));
    var totalPrice = section.querySelector('[data-cleeny-total-price]');
    var topNote = section.querySelector('[data-cleeny-top-note]');
    var saveBadge = section.querySelector('[data-cleeny-save-badge]');
    var summaryLabel = section.querySelector('[data-cleeny-summary-label]');
    var summaryTotal = section.querySelector('[data-cleeny-summary-total]');
    var form = section.querySelector('[data-cleeny-product-form]');
    var variantInput = section.querySelector('[data-cleeny-variant-id]');
    var formQuantity = section.querySelector('[data-cleeny-form-quantity]');
    var addButton = section.querySelector('[data-cleeny-add-button]');
    var addText = section.querySelector('[data-cleeny-add-text]');
    var cartMessage = section.querySelector('[data-cleeny-cart-message]');
    var whatsapp = section.querySelector('[data-cleeny-whatsapp]');

    var quantity = 1;

    function selectedRadio() {
      return radios.find(function (radio) { return radio.checked; }) || radios[0] || null;
    }

    function selectedTotal(qty) {
      return qty === 2 ? doubleTotal : singleTotal;
    }

    function setMessage(text, isError) {
      if (!cartMessage) return;
      cartMessage.textContent = text || '';
      cartMessage.classList.toggle('is-error', Boolean(isError));
      cartMessage.classList.toggle('is-visible', Boolean(text));
    }

    function updateWhatsApp(total) {
      if (!whatsapp || !whatsappNumber) return;
      var productTitle = product.title || 'Color Catcher box';
      var message = 'Hello, I would like to order ' + productTitle + ' x' + quantity + ' for ' + money(total, currency) + '. Delivery is 2$ in Saida and $5 elsewhere in Lebanon.';
      whatsapp.href = 'https://wa.me/' + encodeURIComponent(whatsappNumber) + '?text=' + encodeURIComponent(message);
    }

    function updateUI() {
      var radio = selectedRadio();
      quantity = radio ? Math.max(1, Math.min(2, Number(radio.value || 1))) : 1;

      cards.forEach(function (card) {
        card.classList.toggle('is-selected', Number(card.dataset.tier) === quantity);
      });

      var total = selectedTotal(quantity);
      var regular = singleTotal * quantity;
      var savings = Math.max(0, regular - total);

      if (totalPrice) totalPrice.textContent = money(total, currency);
      if (topNote) topNote.textContent = quantity === 1 ? '1 BOX • 72 SHEETS' : '2 BOXES • 144 SHEETS';
      if (summaryLabel) summaryLabel.textContent = quantity === 1 ? '1 BOX' : '2 BOXES';
      if (summaryTotal) summaryTotal.textContent = money(total, currency);
      if (formQuantity) formQuantity.value = String(quantity);

      if (saveBadge) {
        if (savings > 0) {
          saveBadge.textContent = 'SAVE ' + money(savings, currency);
          saveBadge.classList.remove('is-hidden');
        } else {
          saveBadge.textContent = '';
          saveBadge.classList.add('is-hidden');
        }
      }

      if (addText && addButton && !addButton.disabled) {
        addText.textContent = 'ADD ' + quantity + (quantity === 1 ? ' BOX' : ' BOXES') + ' TO CART  •  ' + money(total, currency);
      }

      updateWhatsApp(total);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', updateUI);
    });

    async function fetchCart(root) {
      var response = await fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Unable to refresh cart.');
      return response.json();
    }

    function publishCartUpdate(cart) {
      try {
        document.dispatchEvent(new CustomEvent('cleeny:cart:updated', { detail: { cart: cart } }));
      } catch (error) {}

      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'cleeny-product-builder',
            cartData: cart
          });
        }
      } catch (error) {}
    }

    async function fallbackAdd(variantId, qty) {
      var root = section.dataset.rootUrl || '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
      });

      var data = await response.json().catch(function () { return {}; });
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add to cart.');

      var cart = await fetchCart(root);
      publishCartUpdate(cart);

      if (window.CleenyCart && typeof window.CleenyCart.refresh === 'function') {
        try { await window.CleenyCart.refresh(); } catch (error) {}
      }

      if (window.CleenyCart && typeof window.CleenyCart.open === 'function') {
        await window.CleenyCart.open();
      } else if (typeof window.openCleenyCartDrawer === 'function') {
        window.openCleenyCartDrawer();
      }

      return data;
    }

    if (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (!addButton || addButton.disabled) return;

        var variantId = variantInput ? Number(variantInput.value) : 0;
        if (!variantId) {
          setMessage('Choose Color Catcher box in the section settings.', true);
          return;
        }

        var loadingText = addButton.dataset.loadingText || 'ADDING';
        addButton.disabled = true;
        if (addText) addText.textContent = loadingText;
        setMessage('', false);

        try {
          if (window.CleenyCart && typeof window.CleenyCart.add === 'function') {
            await window.CleenyCart.add(variantId, quantity);
          } else {
            await fallbackAdd(variantId, quantity);
          }
          setMessage('Added to cart', false);
        } catch (error) {
          setMessage(error && error.message ? error.message : 'Unable to add to cart', true);
        } finally {
          addButton.disabled = false;
          updateUI();
        }
      });
    }

    updateUI();
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.matches && event.target.matches(SELECTOR)) initBuilder(event.target);
    else initAll(event.target);
  });
})();